import React, { useMemo, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TrackVisibility from 'react-on-screen';
import './SuccessStories.css';

// import faces for success story cards
import success_SusitsMatyas from "../../assets/img/success_SusitsMatyas.jpg";
import success_RekaBoros from "../../assets/img/success_RekaBoros.jpg";
import success_AdriennCzako from "../../assets/img/success_AdriennCzako.jpg";
import success_EmeseVastag from "../../assets/img/success_EmeseVastag.jpg";
import success_DominikaVirsinger from "../../assets/img/success_DominikaVirsinger.jpg";
import success_ArturVlaszov from "../../assets/img/success_ArturVlaszov.jpg";
import success_JuditHerman from "../../assets/img/success_JuditHerman.jpg";
import success_KiraKovacs from "../../assets/img/success_KiraKovacs.jpg";
import success_MateGedeon from "../../assets/img/success_MateGedeon.jpg";
import success_PatrikMarozsan from "../../assets/img/success_PatrikMarozsan.jpg";
import success_BenedekMath from "../../assets/img/success_BenedekMath.jpg";
import success_AdamNemes from "../../assets/img/success_AdamNemes.jpg";
import success_PeterVeliczky from "../../assets/img/success_PeterVeliczky.jpg";
import success_KrisztianVarga from "../../assets/img/success_KrisztianVarga.jpg";
import success_KhacHuyNguyen from "../../assets/img/success_KhacHuyNguyen.png";
import success_DomonkosMartos from "../../assets/img/success_DomonkosMartos.png";


// --- NEW Data Structure ---
// Each object now contains a 'content' property holding the raw JSX for that card.
// This gives you complete freedom to structure each card's content differently.
const storiesData = [
  {
    id: 1,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_SusitsMatyas} alt="" className="avatar-img" />
        </div>
        <h3>Mátyás Susits</h3>
        <p>
          Together with his supervisor <strong>Botond Szilágyi</strong>, Mátyás co-authored a research article:
        </p>
        <h4>
          <a href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4613009" target="_blank" rel="noopener noreferrer">PyPINNChem: an Open-source 
          Tool for Chemical Reaction Modeling Using Physics-informed Neural Networks</a>
        </h4>
      </>
    ),
  },
  {
    id: 2,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_RekaBoros} alt="" className="avatar-img" />
          <img src={success_AdriennCzako} alt="" className="avatar-img" />
        </div>
        <h3>Réka Boros & Adrienn Czakó</h3>
        <p>
          With their supervisor <strong>László Csató</strong>, Réka and Adrienn published two research papers in leading Hungarian journals:
        </p>
        <ul>
          <li><h4><a href="https://www.ksh.hu/statszemle_archive/all/2024/2024_08/2024_08_810.pdf" target="_blank" rel="noopener noreferrer">
          Competitive Balance in the UEFA Champions League Group Stage: An Alternative Approach (Statisztikai Szemle)</a></h4></li>
          <li><h4><a href="https://ojs.mtak.hu/index.php/kszemle/article/view/19488/16028" target="_blank" rel="noopener noreferrer">
          Are Swiss-system Chess Tournaments Unfairly Organized? (Közgazdasági Szemle)</a></h4></li>
        </ul>
      </>
    ),
  },
  {
    id: 3,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_EmeseVastag} alt="" className="avatar-img" />
          <img src={success_DominikaVirsinger} alt="" className="avatar-img" />
          <img src={success_ArturVlaszov} alt="" className="avatar-img" />
        </div>
        <h3>Emese Vastag, Dominika Virsinger & Artúr Vlaszov</h3>
        <p>
          Together with their supervisor <strong>Szilvia Bíró-Szigeti</strong>, they published a conference paper:
        </p>
        <h4>
          <a href="https://pea.lib.pte.hu/handle/pea/44518" target="_blank" rel="noopener noreferrer">
          Analyzing Success Factors of Social Media Posts Using Data Science Methods</a>
        </h4>
        {/*<p><em>(Paper pending publication)</em></p> */}
      </>
    ),
  },
  {
    id: 4,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_KiraKovacs} alt="" className="avatar-img" />
          <img src={success_JuditHerman} alt="" className="avatar-img" />
        </div>
        <h3>Kíra Kovács & Judit Hermán</h3>
        <p>
          With their supervisor <strong>Orsolya Vásárhelyi</strong>, Kíra and Judit won <strong>First Prize at TDK, First Prize 
          at OTDK, and the Dean’s Special Award</strong> with their study:
        </p>
        <h4>
          <a href="https://tdk.bme.hu/conference/GTK/2024/sessions/SzocKomFil_2/paper/A-ChatGPT-tarsadalmi-hatasai-Reprezentacio-es" target="_blank" rel="noopener noreferrer">
          Does ChatGPT Distort? – Analyzing the Citation Patterns of Large Language Models</a>
        </h4>
        <p>
          They also presented their research as a poster at the <strong>International Society for Scientometrics and Informetrics 
          (ISSI) Conference</strong>, under the title:
        </p>
        <h4>
          Evaluating the Gender Bias of Large Language Models in Academic Knowledge Production
        </h4>
      </>
    ),
  },
  {
    id: 5,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_MateGedeon} alt="" className="avatar-img" />
          <img src={success_PatrikMarozsan} alt="" className="avatar-img" />
        </div>
        <h3>Máté Gedeon & Patrik Marozsán</h3>
        <p>Supervised by <strong>Pál Danyi</strong>, Máté and Patrik received <strong>Second Prize at TDK</strong> with their project: </p>
        <h4>
          <a href="https://tdk.bme.hu/conference/VIK/2024/sessions/kepfel/paper/Szamtablazatok-Algoritmikus-Feldolgozasa" target="_blank" rel="noopener noreferrer">
            Algorithmic Processing of Spreadsheets: Optical Character Recognition on Historical Price Lists
          </a>
        </h4>
        <p>They also presented their findings at a <strong>Budapest City Archives seminar.</strong></p>
      </>
    ),
  },
  {
    id: 6,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_BenedekMath} alt="" className="avatar-img" />
          <img src={success_AdamNemes} alt="" className="avatar-img" />
        </div>
        <h3>Benedek Máth & Ádám Nemes</h3>
        <p>Together with their supervisor <strong>Balázs Varga</strong>, they received a <strong>Prize-winning TDK Award</strong> for their project: </p>
        <h4>
          <a href ="https://tdk.bme.hu/conference/KJK/2024/sessions/KIR/paper/Graf-Neuralis-Halok-alkalmazasa-2" target="_blank" rel="noopener noreferrer">
            Graph Neural Networks for Traffic Flow Prediction
          </a>
        </h4>
        <p>Their research also resulted in a conference paper at the <strong>International Symposium on Applied Computational Intelligence and Informatics (SACI):</strong></p>
        <h4>
          <a href="https://ieeexplore.ieee.org/document/11030106" target="_blank" rel="noopener noreferrer">
            Iterative GNN-Based Traffic Flow Prediction and Sensor Placement Optimization
          </a>
        </h4>
      </>
    ),
  },
  {
    id: 7,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_KrisztianVarga} alt="" className="avatar-img" />
          <img src={success_PeterVeliczky} alt="" className="avatar-img" />
        </div>
        <h3>Krisztián Varga & Péter Veliczky</h3>
        <p>Supervised by <strong>Balázs Pejó</strong>, their paper was accepted at the <a href="https://satml.org/accepted-papers/#:~:text=On%20the%20Fragility%20of%20Contribution%20Evaluation%20in%20Federated%20Learning" target="_blank" rel="noopener noreferrer">IEEE SaTML 2026 </a> 
          <strong>conference</strong> and was published on arXiv: </p>
        <h4>
          <a href="https://arxiv.org/html/2509.19921v2" target="_blank" rel="noopener noreferrer">
            On the Fragility of Contribution Evaluation in Federated Learning
          </a>
        </h4>
      </>
    ),
  },
  {
    id: 8,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_KhacHuyNguyen} alt="" className="avatar-img" />
        </div>
        <h3>Khac Huy Nguyen</h3>
        <p>Together with his supervisors <strong>Dorottya Szemere</strong>, <strong>Marcell Nagy</strong>, and <strong>Viven Surman</strong>, they published a <strong>research paper</strong>:
        </p>
        <h4>
          <a href="https://pp.bme.hu/tr/article/view/40427" target="_blank" rel="noopener noreferrer">Exploring Trends and Future 
          Research Directions in the Adoption of Electric Micromobility Vehicles</a>
        </h4>
      </>
    ),
  },
  {
    id: 9,
    content: (
      <>
        <div className="story-avatars">
          <img src={success_DomonkosMartos} alt="" className="avatar-img" />
        </div>
        <h3>Domonkos Martos</h3>
        <p>Supervised by <strong>Gergő Orbán</strong>, Domonkos won <strong>First Prize</strong> and the <strong>Bosch Special Award</strong> at ELTE TDK with his study: <strong>Neurally Guided Diffusion for the Visual Cortex</strong>
        </p>
      </>
    ),
  },
];

const Sparkles = () => {
  const numSparkles = 75;
  const sparkleElements = useMemo(() => {
    return Array.from({ length: numSparkles }).map((_, i) => {
      const style = {
        top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%`, width: `${Math.random() * 2 + 1}px`, height: `${Math.random() * 2 + 1}px`, animationDelay: `${Math.random() * 5}s`, animationDuration: `${Math.random() * 3 + 2}s`,
      };
      return <div key={i} className="sparkle" style={style} />;
    });
  }, []);
  return <div className="sparkle-container">{sparkleElements}</div>;
};

// --- Main Component ---
export const SuccessStories = () => {
  
  // --- UPDATED StoryCard Component ---
  // It now accepts a 'children' prop, which is whatever JSX you place inside it.
  // Its only job is to be the styled container.
  const StoryCard = ({ children }) => (
    <div className="story">
      {children}
    </div>
  );

  const ref = useRef();
  useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            window.history.pushState({}, "", "#success-stories");
          }
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.2,
        }
      );
  
      if (ref.current) {
        observer.observe(ref.current);
      }
  
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }, []);

  return (
    <section className="success-stories-container" id="success-stories" ref={ref}>
      <Sparkles />
      
      <div className="stories-content">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__fadeInDown" : ""}>
                    <h2>Project Lab Success Stories</h2>
                    <p className="intro-text">
                      Discover how some projects went from simple classroom assignments to a real world publications.
                    </p>
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>

          <Row className="story-grid-row justify-content-center">
            {storiesData.map((story) => (
              <Col key={story.id} lg={4} md={6} className="mb-4">
                {/* 
                  Here, we pass the JSX content from our data array *as a child*
                  to the StoryCard component.
                */}
                <StoryCard>
                  {story.content}
                </StoryCard>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </section>
  );
};